import styles from '../styles.module.scss';
import { MutableRefObject, ReactElement } from 'react';

type AssignableRef<ValueType> =
  | {
      bivarianceHack(instance: ValueType | null): void;
    }['bivarianceHack']
  | MutableRefObject<ValueType | null>;
interface ToggleProps {
  onClick: React.MouseEventHandler;
  id: string;
  'aria-controls': string;
  'aria-expanded'?: boolean;
  type?: 'button';
  disabled?: boolean;
  'aria-disabled'?: boolean;
  role?: 'button';
  tabIndex?: number;
  ref: AssignableRef<any>;
}

interface ExpandBtnProps {
  isExpanded: boolean;
  getToggleProps: (config?: any) => ToggleProps;
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading?: boolean;
  label?: ReactElement;
}

const ExpandBtn = ({ isExpanded, getToggleProps, setExpanded, isLoading, label }: ExpandBtnProps) => {
  return (
    <div
      className={`${styles['ddListRow']}`}
      {...getToggleProps({
        onClick: () => setExpanded((prevExpanded) => !prevExpanded)
      })}
    >
      <div>
        {isLoading ? (
          <i className="las la-spinner la-spin fs-2x text-secondary"></i>
        ) : (
          <i
            className={
              isExpanded
                ? 'las la-chevron-circle-up fs-2x text-secondary'
                : 'text-secondary las la-chevron-circle-down fs-2x'
            }
          ></i>
        )}
      </div>
      {label && <span className="flex fw-bolder ps-2 pb-1">{label}</span>}
    </div>
  );
};

export default ExpandBtn;
